import React, { useState, useRef, lazy } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'Bono 1: "The Master Dashboard"',
  desc: 'Plantilla lista en Google Sheets/Notion. Tu diario de entrenamiento para registrar KPIs, métricas de acierto y sobrecarga progresiva.',
  // Analytics / dashboard — optimized & cropped
  img: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=240&q=55&auto=format&fit=crop',
  alt: 'Dashboard de métricas y seguimiento de entrenamiento'
}, {
  title: 'Bono 2: "Checklist de Reparación Técnica"',
  desc: 'Tu algoritmo de bolsillo. Un diagrama de flujo imprimible para diagnosticar por qué fallas (bolas a la red, largas) y aplicar parches técnicos inmediatos en tus tiempos muertos.',
  // Checklist / clipboard — optimized & cropped
  img: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=240&q=55&auto=format&fit=crop',
  alt: 'Checklist de reparación técnica imprimible'
}, {
  title: 'Bono 3: Guía Definitiva de Gomas y Maderas',
  desc: 'No compres otra goma hasta leer esto. Decodifica durezas, esponjas, maderas de carbono y marcas (Donic, Loki, etc.) para que tu "Hardware" potencie tu "Software".',
  // Table tennis paddle / equipment — optimized & cropped
  img: 'https://images.unsplash.com/photo-1611251135345-18c56206b863?w=240&q=55&auto=format&fit=crop',
  alt: 'Gomas y maderas de paletas de tenis de mesa'
}];
export function BonusesSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollLeft = scrollRef.current.scrollLeft;
      const width = scrollRef.current.offsetWidth;
      setActiveIndex(Math.round(scrollLeft / width));
    }
  };
  return <section className="py-10 sm:py-16 lg:py-24 bg-navy-900 relative overflow-hidden" data-id="element-35">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-3xl bg-radial-glow opacity-40 pointer-events-none" data-id="element-36" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-37">
        <div className="text-center mb-6 sm:mb-10 lg:mb-12" data-id="element-38">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display text-offwhite uppercase mb-3" data-id="element-39">
            INCLUIDOS GRATIS: <span className="text-gold-500" data-id="element-40">3 Bonos</span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-text-secondary" data-id="element-41">
            Sin costo extra — incluidos en todas las ofertas hoy.
          </p>
        </div>

        {/* Mobile Carousel / Desktop compact list */}
        <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar md:flex-col md:overflow-visible gap-3 sm:gap-4 mb-4 sm:mb-6 md:mb-8 pb-4 md:pb-0" data-id="element-42">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-navy-800 border border-gold-500/30 rounded-2xl relative flex items-stretch overflow-hidden hover:border-gold-500/60 transition-colors shadow-[0_8px_24px_rgba(0,0,0,0.3)] min-w-[88%] sm:min-w-[60%] md:min-w-0 snap-center shrink-0" data-id="element-43">
              {/* Thumbnail image */}
              <div className="relative w-24 sm:w-32 md:w-40 flex-shrink-0 bg-navy-900" data-id="element-44">
                <img src={bono.img} alt={bono.alt} width={240} height={240} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover opacity-90" data-id="element-45" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-navy-800/60" data-id="element-46" />
              </div>

              {/* Content */}
              <div className="flex flex-col justify-center p-3 sm:p-4 md:p-5 flex-grow" data-id="element-47">
                <h3 className="font-bold text-offwhite text-sm sm:text-base md:text-lg mb-1 sm:mb-1.5 leading-tight pr-12 sm:pr-16" data-id="element-48">
                  {bono.title}
                </h3>
                <p className="text-text-secondary text-[11px] sm:text-xs md:text-sm leading-snug line-clamp-3 md:line-clamp-none" data-id="element-49">
                  {bono.desc}
                </p>
              </div>

              {/* GRATIS badge */}
              <div className="absolute top-2 right-2 sm:top-3 sm:right-3 bg-gold-500 text-offwhite font-display text-xs sm:text-sm px-2 py-0.5 sm:px-3 rounded shadow-lg" data-id="element-50">
                GRATIS
              </div>
            </motion.div>)}
        </div>

        {/* Mobile Dots Indicator */}
        <div className="flex justify-center gap-2 mb-6 sm:mb-8 md:hidden" data-id="element-51">
          {bonuses.map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all duration-300 ${activeIndex === i ? 'w-6 bg-gold-500' : 'w-1.5 bg-navy-700'}`} data-id="element-52" />)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-navy-800/80 border border-gold-500/30 rounded-2xl p-4 sm:p-6 md:p-8 max-w-3xl mx-auto backdrop-blur-sm" data-id="element-53">
          <p className="text-xl sm:text-3xl md:text-4xl lg:text-5xl font-display text-gold-400 uppercase tracking-wide" data-id="element-54">
            VALOR TOTAL:{' '}
            <span className="line-through opacity-50 text-offwhite" data-id="element-55">
              $36.000
            </span>{' '}
            — HOY GRATIS
          </p>
        </motion.div>
      </div>
    </section>;
}